import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import EditarIcon from '@mui/icons-material/Edit';

const session = require('../../config/session')

function Row(props) {
 const {cliente} = props

  var cajeros = []
  if (cliente.cajeros != null) {
    const MAX_CAJEROS = 5
    const listaCajeros = cliente.cajeros.split('**-**')
    listaCajeros.slice(0, MAX_CAJEROS).forEach((cajero, index) => {
      cajeros.push(
        <span key={`cajero-${index}`}>* {cajero}<br /></span>
      );
    });
    if (listaCajeros.length > MAX_CAJEROS) {
      const restantes = listaCajeros.length - MAX_CAJEROS
      cajeros.push(
        <span key="cajero-mas" style={{ fontStyle: 'italic', color: '#555' }}>
          + {restantes} {restantes === 1 ? 'cajero' : 'cajeros'}
        </span>
      );
    }
  }

  // Entidades ASOCIADAS al depositante (pueden ser varias); se muestran como lista.
  var entidades = []
  if (cliente.entidad != null && cliente.entidad !== '') {
    const MAX_ENTIDADES = 5
    const listaEntidades = cliente.entidad.split('**-**')
    listaEntidades.slice(0, MAX_ENTIDADES).forEach((ent, index) => {
      entidades.push(
        <span key={`ent-${index}`}>* {ent}<br /></span>
      );
    });
    if (listaEntidades.length > MAX_ENTIDADES) {
      const restantes = listaEntidades.length - MAX_ENTIDADES
      entidades.push(
        <span key="ent-mas" style={{ fontStyle: 'italic', color: '#555' }}>
          + {restantes} {restantes === 1 ? 'entidad' : 'entidades'}
        </span>
      );
    }
  }


 var estado = ""

 switch(cliente.estado) {
  case "A":
    estado = "Activo"
    break
  case "I":
    estado = "Inactivo"
    break
  default:
    break

 }

 return (
   <TableRow>
     <TableCell>
       {cliente.fecha_registro}
     </TableCell>
     <TableCell>
        {cliente.nombre}
     </TableCell>
     <TableCell>
       {cliente.codigo}
    </TableCell>
    <TableCell>
       {entidades}
    </TableCell>
    <TableCell>
      {cajeros}
    </TableCell>
    <TableCell>
      {estado}
    </TableCell>
    <TableCell>
    {
      session.checkPermiso('acceder_depositantes_editar') && 
      <Link to={{pathname: '/dashboard/clientes/editar', state: {id_cliente: cliente.id}}} style={{ textDecoration: 'none' }}><Button variant="contained" endIcon={<EditarIcon />} color="primary">Editar</Button></Link>
    }
    </TableCell>
  </TableRow>
 );
}


class ClientesTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      cajeros: []
    };
  }

  componentDidMount() {
  }

  render() {
    const clientes = this.props.clientes


    const columns = [
      {field: "fecha_registro", headerName: 'Fecha Registro', width: 250},
      {field: "nombre", headerName: 'Nombre', width: 220},
      {field: "codigo", headerName: 'Identificación', width: 170},
      {field: "entidad", headerName: 'Entidad', width: 250},
      {field: "cajeros", headerName: 'Cajeros', width: 250},
      {field: "estado", headerName: 'Estado', width: 100},
      {field: "", headerName: ''},
    ]

    return (
      <Box sx={{ maxWidth: 1200, overflow: 'hidden', borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {clientes.map((cliente, idx) => {
                return(
                  <Row key={idx} cliente={cliente} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default ClientesTable;
